import { MONTHS } from '../types'

interface BloomCalendarProps {
  bloomMonths: number[]
  size?: 'sm' | 'md'
}

export default function BloomCalendar({ bloomMonths, size = 'sm' }: BloomCalendarProps) {
  if (bloomMonths.length === 0) {
    return <p className="text-xs text-ac-brown-light italic font-body">Grown for foliage — no seasonal blooms</p>
  }

  return (
    <div className="flex gap-0.5 flex-wrap">
      {MONTHS.map((m, i) => {
        const blooms = bloomMonths.includes(i + 1)
        return (
          <div key={m} className="flex flex-col items-center gap-0.5">
            <div
              className={`rounded-full transition-all ${size === 'sm' ? 'w-4 h-4' : 'w-6 h-6'}
                ${blooms
                  ? 'bg-ac-pink border-2 border-ac-brown'
                  : 'bg-gray-200 border border-gray-300'
                }`}
              title={blooms ? `Blooms in ${m}` : `No blooms in ${m}`}
            />
            <span className="text-[8px] text-ac-brown-light font-body leading-none">{m[0]}</span>
          </div>
        )
      })}
    </div>
  )
}
